<template>
  <div class="mybox">
    <home-header :isShow="true" :hasMessage="hasMessage"></home-header>
    <div class="mycenter">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple left">
            <!-- <el-avatar :size="80" :src='user.head_portrait'>
              <img src="@/assets/images/headerImg.jpg"/>
            </el-avatar> -->
            <el-image class="avatar" :src="user.head_portrait" fit="cover">
              <img class="avatar_img" slot="error" src="@/assets/images/headerImg.jpg" alt="" />
            </el-image>
            <div class="username">{{ user.nickname }}</div>
            <router-link class="edit-btn" to="/edituserinfo">
              编辑资料</router-link
            >
          </div>
          <div class="btns_list">
            <left-list :activeIndex="activeIndex"></left-list>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content my_right">
            <comment-title titleText="消息中心" :isShow="true"></comment-title>
            <message-list @hasMessage="funcMessage"></message-list>
          </div>
        </el-col>
      </el-row>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";

// import HomeHeader from '@/components/Header'
import HomeFooter from "@/components/Footer";
import CommentTitle from "@/components/Title";
import LeftList from "../components/LeftList";
import MessageList from "../components/MessageList";
export default {
  name: "Message",
  components: {
    HomeHeader,
    HomeFooter,
    CommentTitle,
    LeftList,
    MessageList,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      activeIndex: "2",
      hasMessage: "",
    };
  },
  methods: {
    funcMessage(data) {
      this.hasMessage = data;
    },
  },
  beforeRouteEnter (to, from, next) {
    // ...
    let token = localStorage.getItem('token');
    if(token){
      next();
    }else{
      next('/login')
    }
  }
};


</script>
<style scoped>
.mybox {
  background: #f3f3f3;
}
.mycenter {
  width: 1200px;
  margin: 20px auto;
}
.left {
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  margin-bottom: 20px;
  border-radius: 10px;
}
.left .el-avatar {
  margin-top: 40px;
}
.left .avatar {
  margin-top: 40px;
}
 .left .avatar .avatar_img{
                  width: 80px;
        height: 80px;
        border-radius: 50%;
          object-fit: cover;
        }
.left .username {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin: 40px auto;
}

.my_right {
  background: white;
  padding: 40px 0px 0px 0px;
  border-radius: 10px;
}

.edit-btn {
  width: 100px;
  height: 40px;
  border: 1px solid #999999;
  border-radius: 20px;
  line-height: 40px;
  text-align: center;
  color: #999999;
  margin-bottom: 60px;
  cursor: pointer;
}
.avatar {
  /* margin-left: 59px; */
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #58b75b;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/my/Pages/Message.vue